import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryptoBankingHero from "./CryptoBankingHero";
import FinanceRedefined from "./FinanceRedefined";
import StakingAndYield from "./StakingAndYield";
import LowerFees from "./LowerFees";
import AppofCryptoBank from "./AppofCryptoBank";
import BlockchainExpertise from "../../AMM DEX/BlockchainExpertise";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function CryptoBanking() {
  return (
    <div>
      <Header />
      <CryptoBankingHero />
      <FinanceRedefined />
      <StakingAndYield />
      <LowerFees />
      <AppofCryptoBank />
      {/* <BlockchainExpertise /> */}
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default CryptoBanking;
